import { Box, Drawer, List } from "@mui/material";
import SideBarContent from "./SideBarContent";
import UserInfo from "../../../../pages/UserGuide/UserInfo";
import { FC } from "react";
import { USER_TYPES } from "../../../../constants/user-types";
import { styles } from "../styles";

const MobileSideBar: FC<{
  handleUserManual: () => void;
  closeMobileSideBar: any;
  showMobileSideBar: any;
  isRightUser: any;
}> = ({
  closeMobileSideBar,
  showMobileSideBar,
  handleUserManual,
  isRightUser,
}) => {
  return (
    <Drawer
      anchor="left"
      open={showMobileSideBar}
      onClose={closeMobileSideBar}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "300px",
          backgroundColor: "#1F5A2D",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#1F5A2D",
        }}
      >
        <Box sx={{ height: "90vh" }}>
          <SideBarContent />
        </Box>

        <Box sx={{ padding: "0px 10px 10px 10px" }}>
          <List sx={styles.menuListContainer}>
            {!isRightUser([USER_TYPES.SYSTEM_USER]) && <UserInfo />}
          </List>
        </Box>
      </Box>
    </Drawer>
  );
};

export default MobileSideBar;
